import type {
  LauncherSyncStatus,
  SystemVersion,
  UpdateInfo,
  UpdateStatus,
  AgentUpdateResult,
  AgentUpdateAccepted,
  PanelRelease,
} from '@mcpanel/core';
import { rawRequest } from './client';
export const updatesApi = {
  version: () => rawRequest<SystemVersion>('GET', '/system/version'),
  releases: () => rawRequest<PanelRelease[]>('GET', '/system/releases'),
  launcherSync: () => rawRequest<LauncherSyncStatus>('POST', '/system/launcher-sync'),
  check: () => rawRequest<UpdateInfo>('POST', '/system/update/check'),
  update: (version: string) => rawRequest<UpdateStatus>('POST', '/system/update', { version }),
  autoDeploy: (enabled: boolean) => rawRequest<{ enabled: boolean }>('PUT', '/system/auto-deploy', { enabled }),
  status: () => rawRequest<UpdateStatus | null>('GET', '/system/update/status'),
  agent: (id: string) => rawRequest<AgentUpdateAccepted>('POST', `/servers/${encodeURIComponent(id)}/agent/update`),
  agents: () => rawRequest<AgentUpdateResult[]>('POST', '/agents/update'),
};
